import { useEffect, useId, useRef, useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from './useNotifications';
import { NotificationPopover } from './NotificationPopover';
import styles from './NotificationBell.module.css';

export function NotificationBell() {
  const { list, unreadCount, hasHighPriorityUnread, markRead, markAllRead } = useNotifications();
  const [open, setOpen] = useState(false);
  const popRef = useRef<HTMLDivElement | null>(null);
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const popId = useId();

  useEffect(() => {
    const el = popRef.current;
    if (!el) return;
    try {
      if (open) (el as HTMLElement & { showPopover?: () => void }).showPopover?.();
      else (el as HTMLElement & { hidePopover?: () => void }).hidePopover?.();
    } catch { /* popover API indisponível — fallback CSS */ }
  }, [open]);

  // Fecha ao clicar fora
  useEffect(() => {
    if (!open) return;
    function onDown(e: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node) &&
          popRef.current && !popRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  return (
    <div className={styles.wrap} ref={wrapRef}>
      <button
        type="button"
        className={styles.btn}
        aria-label={`Notificações${unreadCount ? ` (${unreadCount} não lidas)` : ''}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <Bell size={18} className={hasHighPriorityUnread ? styles.pulse : undefined} />
        {unreadCount > 0 && <span className={styles.badge}>{unreadCount > 9 ? '9+' : unreadCount}</span>}
      </button>
      <div
        ref={popRef}
        id={popId}
        popover="manual"
        className={styles.layer}
      >
        {open && (
          <NotificationPopover
            items={list}
            onMarkRead={markRead}
            onMarkAllRead={markAllRead}
            onClose={() => setOpen(false)}
          />
        )}
      </div>
    </div>
  );
}
